import { render, staticRenderFns } from "./TipoNotificacaoSelect.vue?vue&type=template&id=09619cbb"
import script from "./TipoNotificacaoSelect.vue?vue&type=script&lang=js"
export * from "./TipoNotificacaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports